var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFolderHoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 170,
    viewBox: "0 0 132 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 130,
    height: 168,
    rx: 3,
    stroke: "#3537E5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 86H67V92H65V86H59V84H65V78H67V84H73V86Z",
    fill: "#3537E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolderHoveredIcon);
export default __webpack_public_path__ + "static/media/new-folder-hovered-icon.92891d0e19f24c4fed5597f83349fe0c.svg";
export { ForwardRef as ReactComponent };